import styled, { css } from 'styled-components';
import { modernViewportUnit } from '../../../design-tokens/style-utilities';
const bottomSheetContainerStyles = ({ theme }) => css `
	z-index: ${Number(theme.zIndex.popUp) + 1};
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: ${modernViewportUnit(100, 'dvh')};
	background-color: ${theme.colors.base.overlay};
`;
export const BottomSheetContainer = styled.div `
	${bottomSheetContainerStyles}
`;
export const BottomSheetContent = styled.div(({ theme }) => css `
		position: absolute;
		bottom: 0;
		width: 100vw;
		background-color: ${theme.colors.blanc.bgModal};
	`);
